import React, { useEffect, useState, useRef, useCallback } from "react";
import { Spin, Select, DatePicker, Checkbox, Form, Button, Table, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getProductStatus } from "../../redux/actions/productStatus.actions";
import { getSeason } from "../../redux/actions/season.action";
import { getGender } from "../../redux/actions/gender.action";
import { ReadCookie } from "../../utils/readCookie";
import moment from "moment";
import btnPrint from "../../assets/images/button_print.gif";
import xlsx from "../../assets/images/ico_xls_sm.gif";
import logo from "../../assets/images/logo-black.svg";
import "../Distributor/Distributor.css";
import { useHistory } from "react-router-dom";
import Loader from "react-loader-spinner";
import { TabTitle } from "../../utils/GeneralFunction";
import { CSVLink } from "react-csv";
import numeral from "numeral";
import { loadCustomers } from "../../redux/actions/customerForm";
import { loadSalePerson } from "../../redux/actions/salePerson/salePersonForm.action";
import { getAdminLocation } from "../../redux/actions/adminLocation.action";
import { getRegion } from "../../redux/actions/region.action";
import { getPaymentTerm } from "../../redux/actions/paymentterm.action";
import { getReturnAuthorizationReport, getReturnBulkPendingReport } from "../../redux/actions/returnAuthorizationReport.action";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
const dateFormatList = ["MM-DD-YYYY"];

const ReturnAuthorizationReport = ({ token }) => {
  TabTitle("Return-Authorization-Report")
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const {
    gender,
    returnauth,
    customerForms,
    region,
    paymentterm,
    adminLocation,
    salePersonForm,
    returnBulkPending
  } = useSelector((state) => state);
  const history = useHistory();
  const menuId = ReadCookie("menuId");
  const userName = ReadCookie("name");
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([])
  const [data2, setData2] = useState([])
  const tableRef = useRef(null);
  const [excelData, setExcelData] = useState([])
  const [customer, setCustomer] = useState("All");
  const [groupedData, setGroupedData] = useState({});
  const [fileName, setFileName] = useState("");
  const { Option } = Select;


  // let result =
  //   returnauth &&
  //   returnauth?.payload?.data?.reduce(function (r, a) {
  //     r[a.bulk_ra_approval_no] = r[a.bulk_ra_approval_no] || [];
  //     r[a.bulk_ra_approval_no].push(a);
  //     return r;
  //   }, Object.create(null));

  // const wiseStockReport = result && Object.values(result);


  // const groupedData = returnauth?.payload?.data.reduce((acc, item) => {
  //   if (!acc[item.bulk_ra_approval_no]) {
  //     acc[item.bulk_ra_approval_no] = [];
  //   }
  //   acc[item.bulk_ra_approval_no].push(item);
  //   return acc;
  // }, {});

  // console.log({ groupedData })


  const onFinish = async (type) => {
    setLoading(true);
    try {
      await form.validateFields().then((values) => {
        if (type === "authorization") {
          // clear pending data
          setData2([]);
          setGroupedData({});

          dispatch(getReturnAuthorizationReport(token, values)).then((res) => {
            setLoading(false);

            const rawData = res?.payload?.data || [];

            // group data locally
            const grouped = rawData.reduce((acc, item) => {
              if (!acc[item.bulk_ra_approval_no]) {
                acc[item.bulk_ra_approval_no] = [];
              }
              acc[item.bulk_ra_approval_no].push(item);
              return acc;
            }, {});
            setGroupedData(grouped);
            downloadExcelFileData(rawData);
            setFileName("Return-Authorization-Report.csv");
          });
        } else if (type === "bulkPending") {
          // clear received data
          setGroupedData({});
          setData2([]);
          dispatch(getReturnBulkPendingReport(token, values)).then((res) => {
            setLoading(false);
            const rawData = res?.payload?.data || [];
            setData2(rawData);
            // 🔹 Excel ke liye
            downloadExcelFilePendingData(rawData);
            setFileName("Return-Pending-Report.csv");
          });
        }
      });
    } catch (error) {
      setLoading(false);
      console.error("Error in onFinish:", error);
    }
  };







  // const onFinish = async (type) => {
  //   setLoading(true);
  //   try {
  //     await form.validateFields().then((values) => {
  //       if (type === "authorization") {
  //         setData2([]);
  //         dispatch(getReturnAuthorizationReport(token, values)).then((res) => {
  //           setLoading(false);
  //           downloadExcelFileData(res?.payload?.data);
  //           setData(res?.payload?.data);
  //         });
  //       } else if (type === "bulkPending") {
  //         setData([]);
  //         dispatch(getReturnBulkPendingReport(token, values)).then((res) => {
  //           setLoading(false);
  //           setData2(res?.payload?.data);
  //         });
  //       }
  //     });
  //   } catch (error) {
  //     setLoading(false);
  //     console.error("Error in onFinish:", error);
  //   }
  // };

  function downloadExcelFileData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "Bulk Return#": v.bulk_return_no,
          "Bulk RA Approval#": v.bulk_ra_approval_no,
          "Bulk Return Date": v.bulk_return_date,
          "Bulk RA Qty": v.bulk_ra_quantity,
          "Bulk RA Amount": v.bulk_ra_net_amount,
          "Return#": v.return_header_no,
          "RA Approval#": v.bulk_ra_approval_no,
          "Return Date": moment(v.return_date).format("MM-DD-YYYY"),
          "RA Qty": v.quantity,
          "RA Amount": v.net_amount,
          "Receipt#": v.receipt_header_no,
          "Receipt Qty": v.receipt_qty,
          "Receipt Amount": v.receipt_net_amount,
          "Credit Note#": v.note_header_no,
          "CN Qty": v.note_qty,
          "CN Amount": v.note_net_amount,
          "Invoice#": v.invoice_header_no,
          "Customer": v.customer_name,
          "SalesPerson": v.salesperson_name,
          "Gender": v.gender_name,
          "Region": v.region_name,
          "Location": v.location_name,
          "Term": v.term_name,
          "LOT#": v.lot_no,
        }
      })
    )
  }

  function downloadExcelFilePendingData(data) {
    setExcelData(
      data.map((v) => {
        return {
          "Return#": v.bulk_return_no,
          "RA Approval#": v.bulk_ra_approval_no,
          "Return Date": moment(v.bulk_return_date).format("MM-DD-YYYY"),
          "RA Qty": v.bulk_ra_quantity,
          "RA Amount": v.bulk_ra_net_amount,
          "Invoice#": v.bulk_invoice_no,
          "Customer": v.customer_name,
          "SalesPerson": v.salesperson_name,
          "Gender": v.gender_name,
          "Region": v.region_name,
          "Location": v.location_name,
          "Term": v.term_name,
        };
      })
    );
  }

  useEffect(() => {
    dispatch(getGender(token, menuId));
    dispatch(loadSalePerson(token));
    dispatch(getAdminLocation(token, menuId));
    dispatch(getRegion(token, menuId));
    dispatch(getPaymentTerm(token, menuId));
  }, [dispatch, menuId, token]);




  const handlePrint = () => {
    window.print();
  };



  const columns = [
    {
      title: "#",
      className: "b_bottom",
      render: (text, record, index) => {
        return index + 1
      },
    },
    {
      title: "Return#",
      dataIndex: "return_header_no",
      key: "return_header_no",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <Link
            to={`/return-authorization?mode=edit&return_id=${record.return_header_id}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue" }}
          >
            {text}
          </Link>
        );
      },
    },
    {
      title: "RA Approval#",
      dataIndex: "bulk_ra_approval_no",
      key: "bulk_ra_approval_no",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
    },
    {
      title: "Return Date",
      dataIndex: "return_date",
      key: "return_date",
      className: "b_left b_right_none b_bottom",
      render: (text, record) => {
        return (
          moment(text).format("MM-DD-YYYY")
        )
      },
    },
    {
      title: "RA Qty",
      dataIndex: "quantity",
      key: "quantity",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
    },
    {
      title: "RA Amount",
      dataIndex: "net_amount",
      key: "net_amount",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${numeral(text).format("0,0.00")}
          </>
        );
      },
    },
    {
      title: "Receipt#",
      dataIndex: "receipt_header_no",
      key: "receipt_header_no",
      className: "b_left b_bottom",
      render: (text, record) => {
        return (
          <Link
            to={`/item-receipt-new?mode=edit&return_id=${record.receipt_header_id}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue" }}
          >
            {text}
          </Link>
        );
      },
    },
    {
      title: "Receipt Qty",
      dataIndex: "receipt_qty",
      key: "receipt_qty",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
    },
    {
      title: "Receipt Amount",
      dataIndex: "receipt_net_amount",
      key: "receipt_net_amount",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${numeral(text).format("0,0.00")}
          </>
        );
      },
    },
    {
      title: "Credit Note#",
      dataIndex: "note_header_no",
      key: "note_header_no",
      className: "b_left b_bottom",
      render: (text, record) => {
        return (
          <Link
            to={`/credit-note/edit/${record.note_header_id}?edit=yes`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue" }}
          >
            {text}
          </Link>
        );
      },
    },
    {
      title: "CN Qty",
      dataIndex: "note_qty",
      key: "note_qty",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
    },
    {
      title: "CN Amount",
      dataIndex: "note_net_amount",
      key: "note_net_amount",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${numeral(text).format("0,0.00")}
          </>
        );
      },
    },
    {
      title: "Invoice#",
      dataIndex: "invoice_header_no",
      key: "invoice_header_no",
      className: "b_left b_bottom",
    },
    {
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      className: "b_left b_right_none b_bottom",
    },
    {
      title: "SalesPerson",
      dataIndex: "salesperson_name",
      key: "salesperson_name",
      className: " b_left b_bottom",
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
      className: " b_left b_bottom",
    },
    {
      title: "Region",
      dataIndex: "region_name",
      key: "region_name",
      className: " b_left b_bottom",
    },
    {
      title: "Location",
      dataIndex: "location_name",
      key: "location_name",
      className: " b_left b_bottom",
    },
    {
      title: "Term",
      dataIndex: "term_name",
      key: "term_name",
      className: " b_left b_bottom",
    },
    {
      title: "LOT#",
      dataIndex: "lot_no",
      key: "lot_no",
      className: " b_left b_bottom",
    },
  ];

  const columnsNew = [
    {
      title: "#",
      className: "b_bottom",
      render: (text, record, index) => {
        return index + 1
      },
    },
    {
      title: "Return#",
      dataIndex: "bulk_return_no",
      key: "bulk_return_no",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <Link
            to={`/return-authorization?mode=edit&return_id=${record.bulk_return_id}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "blue" }}
          >
            {text}
          </Link>
        );
      },
    },
    {
      title: "RA Approval#",
      dataIndex: "bulk_ra_approval_no",
      key: "bulk_ra_approval_no",
      className: " b_left b_bottom",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
    },
    {
      title: "Return Date",
      dataIndex: "bulk_return_date",
      key: "bulk_return_date",
      className: "b_left b_right_none b_bottom",
      render: (text, record) => {
        return (
          moment(text).format("MM-DD-YYYY")
        )
      },
    },
    {
      title: "RA Qty",
      dataIndex: "bulk_ra_quantity",
      key: "bulk_ra_quantity",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            {text}
          </>
        );
      },
    },
    {
      title: "RA Amount",
      dataIndex: "bulk_ra_net_amount",
      key: "bulk_ra_net_amount",
      className: " b_left b_bottom",
      align: "right",
      render: (text, record) => {
        return (
          <>
            ${numeral(text).format("0,0.00")}
          </>
        );
      },
    },
    {
      title: "Invoice#",
      dataIndex: "bulk_invoice_no",
      key: "bulk_invoice_no",
      className: "b_left b_bottom",
    },
    {
      title: "Customer",
      dataIndex: "customer_name",
      key: "customer_name",
      className: "b_left b_right_none b_bottom",
    },
    {
      title: "SalesPerson",
      dataIndex: "salesperson_name",
      key: "salesperson_name",
      className: " b_left b_bottom",
    },
    {
      title: "Gender",
      dataIndex: "gender_name",
      key: "gender_name",
      className: " b_left b_bottom",
    },
    {
      title: "Region",
      dataIndex: "region_name",
      key: "region_name",
      className: " b_left b_bottom",
    },
    {
      title: "Location",
      dataIndex: "location_name",
      key: "location_name",
      className: " b_left b_bottom",
    },
    {
      title: "Term",
      dataIndex: "term_name",
      key: "term_name",
      className: " b_left b_bottom",
    },
    {
      title: "SKU",
      key: "sku",
      className: "b_left b_bottom",
      render: () => {
        const sku = form.getFieldValue("sku");
        return sku ? sku : "-";
      },
    }
  ];


  function debounce(cb, delay = 1000) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        cb(...args);
      }, delay);
    };
  }

  const handleChanges = (val) => {
    if (val === "" || val === "All") return;
    setCustomer(val);
    dispatch(loadCustomers(token, null, null, null, null, null, val, null, null, null, null, null, null, null, null, null, null, null, null)).then(
      (res) => {
        if (res?.type === "GET_ALL_CUSTOMERS_SUCCESS") {
          setCustomer(res?.payload?.data);
        }
      }
    );
  };

  const optimizedCus = useCallback(debounce(handleChanges), []);


  return (
    <div className="header_class business_header_oms">
      <div className="row justify-content-between business_class_oms distributor">
        <div className="col-3 d-flex align-items-start box-space">
          <div className="logobrand">
            <img id="ImgLogo" alt="logo" src={logo} />
          </div>
        </div>
        <div className="col-4 box-space right-content-header text-right">
          <div className=" d-flex justify-content-end">
            <div className=" d-flex justify-content-end mr-8">
              <div className="print_icon printing_class">
                <i
                  onClick={handlePrint}
                  id="Image1"
                  title="Print"
                  alt="Print"
                  src={btnPrint}
                  className="fa-solid fa-print"
                ></i>
              </div>
              <div className="print_icon printing_class">
                <CSVLink
                  filename={fileName}
                  data={excelData}
                >
                  <input
                    type="image"
                    name="ImgExcel"
                    alt="Export to excel"
                    id="ImgExcel"
                    title="Export to excel"
                    src={xlsx}
                  />
                </CSVLink>
              </div>
            </div>
            <span style={{ fontSize: "small", fontWeight: "bolder" }}>
              Return Authorization Report
              <br />
              Rpt # 489
              <br />
              <p className=" mb-0">Rpt # 001_V4</p>
              Login as:{" "}
              <span id="lblSalesPerson" style={{ fontWeight: "bold" }}>
                {userName}
              </span>
            </span>
          </div>
        </div>
      </div>
      <div className="business_class_oms mb-2 distributor">
        <Form form={form} name="control-hooks" onFinish={onFinish}>
          <div className="main_form row">
            <div className="col-12">
              <hr className="my-1" />
              <div className="main_form row">
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Customer</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item name="customer" initialValue={"All"}>
                        <Select
                          // filterSort={(optionA, optionB) =>
                          //   optionB?.value !== null ?
                          //     optionA?.children[1]?.toLowerCase()?.localeCompare(optionB?.children[1]?.toLowerCase()) : ''
                          // }
                          notFoundContent={
                            customerForms.loading ? (
                              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}                              >
                                <Loader type="Oval" color="#3c4b58" height={20} width={20} />
                              </div>
                            ) : (
                              <div style={{ display: "flex", justifyContent: "center", alignItems: "center", textAlign: "center" }} >
                                No Data
                              </div>
                            )}
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                          loading={customerForms.loading}
                          onSearch={(value) => {
                            optimizedCus(value);
                          }}
                        >
                          <Option value={"All"}>All</Option>
                          {customerForms?.payload?.data.map((item) => {
                            return (
                              <Option
                                key={item.customer_id}
                                value={item.customer_id}
                              >
                                {`${item.customer_name}`}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/*Second*/}
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Region</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item name="region_id" initialValue={"All"}>
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value={"All"}>All</Option>
                          {
                            region?.payload?.data.map((val) => {
                              return (
                                <Option key={val.region_id} value={val.region_id}>{val.region_name}</Option>
                              )
                            })
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Gender</label>
                    <div className="w-100">
                      <Form.Item name="gender_id" initialValue={"All"}>
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value={"All"}>All</Option>
                          {gender &&
                            gender?.payload?.data.map((it, index) => {
                              return (
                                <Option key={index} value={it.gender_id}>
                                  {it.gender_name}
                                </Option>
                              );
                            })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Term</label>
                    <div className="w-100">
                      <Form.Item name="term_id" initialValue={"All"}>
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value={"All"}>All</Option>
                          {paymentterm?.payload?.data.map((item) => {
                            return (
                              <Option key={item.term_id} value={item.term_id} >
                                {item.term_name}
                              </Option>
                            );
                          }
                          )}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">Location</label>
                    <div className="w-100">
                      <Form.Item name="location_id" initialValue={"All"}>
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value={"All"}>All</Option>
                          {adminLocation?.payload?.data.map((val, index) => {
                            return (
                              <Option key={val.location_id} value={val.location_id}>
                                {val.location_name}
                              </Option>
                            );
                          })}
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">SalesPerson</label>
                    <div className="w-100 fit-selectbox-width">
                      <Form.Item name="salesperson_id" initialValue={"All"}>
                        <Select
                          className={"select_Inputs"}
                          showSearch
                          optionFilterProp="children"
                          size="small"
                        >
                          <Option value={"All"}>All</Option>
                          {
                            salePersonForm?.payload?.data.map((val, index) => {
                              return (
                                <Option key={index} value={val.sales_person_id}>{val.salesperson_name}</Option>
                              )
                            })
                          }
                        </Select>
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/*Third*/}
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">From Date</label>
                    <div className="w-100">
                      <Form.Item
                        name="from_date"
                        className="full_date"
                        initialValue={moment().startOf('year')}
                      >
                        <DatePicker
                          size="small"
                          format={dateFormatList}
                          defaultValue={moment().format("MM-DD-YYYY")}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                {/*Fourth*/}
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44" htmlFor="">To Date</label>
                    <div className="w-100">
                      <Form.Item
                        name="to_date"
                        className="full_date"
                        initialValue={moment().endOf('day')}
                      >
                        <DatePicker
                          size="small"
                          format={dateFormatList}
                          defaultValue={moment().format("MM-DD-YYYY")}
                        />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44">RA Approval</label>
                    <div className="w-100">
                      <Form.Item name="ra_approval" className="sku_input">
                        <Input size="small" className={"select_Inputs mb-0"} />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44">LOT#</label>
                    <div className="w-100">
                      <Form.Item name="lot_no" className="sku_input">
                        <Input size="small" className={"select_Inputs mb-0"} />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className=" d-flex flex-row align-items-baseline">
                    <label className="labels width44">SKU</label>
                    <div className="w-100">
                      <Form.Item name="sku" className="sku_input">
                        <Input size="small" className={"select_Inputs mb-0"} />
                      </Form.Item>
                    </div>
                  </div>
                </div>
                <div className="col-12 col-md-3">
                  <div className="d-flex flex-row align-items-baseline">
                    {/* <label className="no_visibility">none</label> */}
                    <Button
                      style={{ width: "fit-content" }}
                      type="primary"
                      htmlType="button"
                      className="submit-btn-btm m-1 float-end"
                      onClick={() => onFinish("authorization")}  // <-- Generate button
                    >
                      Received
                    </Button>
                    <Button
                      style={{ width: "fit-content" }}
                      type="primary"
                      htmlType="button"
                      className="submit-btn-btm m-1 float-end mx-4"
                      onClick={() => onFinish("bulkPending")}   // <-- New Generate button
                    >
                      Pending
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>
      <div className="table_content"
        style={{ width: '1600px', paddingTop: "25px" }}
        ref={tableRef}
      >
        {/* Loader */}
        <div>
          {loading && (
            <div className="loader" style={{ marginTop: "20px" }}>
              <Spin size="medium" />
            </div>
          )}

          {/* Received Table */}
          {!loading && Object.keys(groupedData || {}).length > 0 ? (
            Object.entries(groupedData).map(([bulkReturnNo, data]) => (
              <div key={bulkReturnNo}>
                <div style={{ paddingBottom: "0px" }}>
                  {(() => {
                    if (!data?.length) return null;

                    const bulkReturnNos = data[0]?.bulk_return_no?.split(",") || [];
                    const returnID = data[0]?.bulk_return_id?.split(",") || [];
                    const dates = data[0]?.bulk_return_date?.split(",") || [];
                    const qtys = data[0]?.bulk_ra_quantity?.split(",") || [];
                    const amounts = data[0]?.bulk_ra_net_amount?.split(",") || [];
                    const approval = data[0]?.bulk_ra_approval_no || "";

                    return bulkReturnNos.map((no, index) => (
                      <div
                        key={index}
                        style={{
                          marginBottom: "4px",
                          display: "grid",
                          gridTemplateColumns: "180px 210px 230px 150px 200px 180px",
                          gap: "6px",
                          width: "70%"
                        }}
                      >
                        <div>
                          Bulk Return#:{" "}
                          <Link
                            to={`/return-authorization?mode=edit&return_id=${returnID[index]}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: "blue" }}
                          >
                            {no}
                          </Link>
                        </div>
                        <div>Bulk RA Approval#: {approval}</div>
                        <div>
                          Bulk Return Date:{" "}
                          {dates[index] ? moment(dates[index]).format("MM-DD-YYYY") : ""}
                        </div>
                        <div>Bulk RA Qty: {qtys[index] || ""}</div>
                        <div>
                          Bulk RA Amount:{" "}
                          {amounts[index] ? numeral(amounts[index]).format("$0,0.00") : ""}
                        </div>
                        {form.getFieldValue("sku") && (
                          <div>
                            SKU: {form.getFieldValue("sku")}
                          </div>
                        )}
                      </div>
                    ));
                  })()}
                </div>

                <Table
                  style={{ fontSize: "10.3px" }}
                  className="test04 mt-3 sales_target_report_table sales_report_res_table sales_target_report_table_dashboard speciality_state"
                  size="small"
                  bordered
                  columns={columns}
                  scroll={{ x: "max-content" }}
                  dataSource={data || []}
                  pagination={{ pageSize: 100 }}
                  rowClassName={(record) => {
                    const q = parseFloat(record.quantity || 0);
                    const rq = parseFloat(record.receipt_qty || 0);
                    const nq = parseFloat(record.note_qty || 0);
                    return q !== rq || q !== nq || rq !== nq ? "highlight-row" : "";
                  }}
                  summary={() => {
                    const rows = data || [];
                    let raQty = rows.reduce((p, c) => p + parseFloat(c.quantity || 0), 0);
                    let raAmount = rows.reduce((p, c) => p + parseFloat(c.net_amount || 0), 0);
                    let receiptQty = rows.reduce((p, c) => p + parseFloat(c.receipt_qty || 0), 0);
                    let receiptAmount = rows.reduce((p, c) => p + parseFloat(c.receipt_net_amount || 0), 0);
                    let noteQty = rows.reduce((p, c) => p + parseFloat(c.note_qty || 0), 0);
                    let noteAmount = rows.reduce((p, c) => p + parseFloat(c.note_net_amount || 0), 0);

                    return (
                      <Table.Summary.Row>
                        <Table.Summary.Cell />
                        <Table.Summary.Cell />
                        <Table.Summary.Cell />
                        <Table.Summary.Cell className="sales_table_summary">
                          <p style={{ fontWeight: "bolder", textAlign: "right" }}>Total</p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell className="sales_table_summary">
                          <p style={{ fontWeight: "bolder", textAlign: "right" }} className="totalquantity">
                            {numeral(raQty).format("0,0")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell className="sales_table_summary">
                          <p style={{ fontWeight: "bolder", textAlign: "right" }} className="totalquantity">
                            {numeral(raAmount).format("$0,0.00")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell />
                        <Table.Summary.Cell className="sales_table_summary">
                          <p style={{ fontWeight: "bolder", textAlign: "right" }} className="totalquantity">
                            {numeral(receiptQty).format("0,0")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell className="sales_table_summary">
                          <p style={{ fontWeight: "bolder", textAlign: "right" }} className="totalquantity">
                            {numeral(receiptAmount).format("$0,0.00")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell />
                        <Table.Summary.Cell className="sales_table_summary">
                          <p style={{ fontWeight: "bolder", textAlign: "right" }} className="totalquantity">
                            {numeral(noteQty).format("0,0")}
                          </p>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell className="sales_table_summary">
                          <p style={{ fontWeight: "bolder", textAlign: "right" }} className="totalquantity">
                            {numeral(noteAmount).format("$0,0.00")}
                          </p>
                        </Table.Summary.Cell>
                      </Table.Summary.Row>
                    );
                  }}
                />
              </div>
            ))
          ) : !loading && data2?.length > 0 ? (
            // Pending Table
            <Table
              className="test04 mt-3 sales_target_report_table sales_report_res_table sales_target_report_table_dashboard speciality_state"
              ref={tableRef}
              size="small"
              bordered={false}
              type="company"
              headerClassName="abc"
              dataSource={data2 || []}
              columns={columnsNew}
              pagination={{ pageSize: 500 }}
              scroll={{ x: "max-content" }}
            />
          ) : (
            !loading && (
              <div className="no-Data">
                <h1>No Data</h1>
              </div>
            )
          )}
        </div>

      </div>

    </div>
  );
};

export default ReturnAuthorizationReport;
